import React, { useState, useEffect } from "react";
import ApiClient from "../services/api-client";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useStore from "../hooks/useStore";

export default function InvoiceTypeSearch() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [invoiceTypes, setInvoiceTypes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');

    useEffect(() => {
        const companyId = useStore.getState().selectedCompany.id;
        ApiClient.getCompanyInvoiceTypes(companyId).then(
            response => {
                if (response) setInvoiceTypes(response.data);
                setLoading(false);
            },
            () => setLoading(false)
        );
    }, []);

    const filtered = invoiceTypes.filter(it => {
        if (!search) return true;
        const q = search.toLowerCase();
        return (
            it.name?.toLowerCase().includes(q) ||
            it.myDataInvoiceType?.toLowerCase().includes(q) ||
            it.seriesNamesConcat?.toLowerCase().includes(q)
        );
    });

    return (
        <div className="container template-search-container">

            <div className="template-search-header">
                <div className="template-search-header-icon">
                    <i className="fa fa-list-alt"></i>
                </div>
                <h4 className="template-search-title">{t("invtypeSearch")}</h4>
            </div>

            <div className="d-flex justify-content-between align-items-center mb-4">
                <div style={{ flex: 1 }} />
                <input
                    className="form-control"
                    style={{ maxWidth: 320 }}
                    placeholder={t("Search")}
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
                <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                    <button className="btn btn-skin ms-3" onClick={() => navigate("/invoicetype")}>
                        <span className="desktop-only">{t("invtypeAdd")} </span>
                        <i className="fa fa-plus"></i>
                    </button>
                </div>
            </div>

            {loading ? (
                <div className="template-search-empty">
                    <i className="fa fa-spinner fa-spin fa-2x" style={{ color: 'var(--appcolor)', opacity: 0.5 }}></i>
                </div>
            ) : filtered.length === 0 ? (
                <div className="template-search-empty">
                    <i className="fa fa-list-alt fa-3x"></i>
                    <p>{t("noResults")}</p>
                </div>
            ) : (
                <div className="row g-3">
                    {filtered.map(it => (
                        <div className="col-xl-3 col-lg-4 col-md-6" key={it.id}>
                            <div className="template-card invtype-card" onClick={() => navigate("/invoicetype/" + it.id)} style={{ cursor: 'pointer' }}>
                                <div className="invtype-card-header">
                                    <span className="invtype-card-type-bubble">
                                        {it.myDataInvoiceType?.replace(/^invoice_?/, "").replace(/_/g, ".")}
                                    </span>
                                    <span className="invtype-card-name">{it.name}</span>
                                </div>
                                <div className="template-card-info">
                                    <div className="invtype-card-type-row">
                                        <span className="invtype-card-type-label">{t(it.myDataInvoiceType)}</span>
                                    </div>
                                    {it.seriesNamesConcat && (
                                        <div className="invtype-card-series">
                                            {it.seriesNamesConcat.split(",").map((s, i) => (
                                                <div key={i} className="invtype-card-series-row">
                                                    <i className="fa fa-tag"></i>
                                                    {s.trim()}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
